import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import HomePage from './pages/HomePage';
import InventoryPage from './pages/InventoryPage';
import SitemapPage from './pages/SitemapPage';
import CategoryPage from './pages/CategoryPage';
import ComparePage from './pages/ComparePage';
import CompareBar from './components/CompareBar';
import ProductPage from './pages/ProductPage';
import NewsListPage from './pages/NewsListPage';
import NewsArticlePage from './pages/NewsArticlePage';
import RFQFormPage from './pages/RFQFormPage';
import AgentCommercePage from './pages/AgentCommercePage';
import ForAgentsPage from './pages/ForAgentsPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminRFQs from './pages/admin/AdminRFQs';
import AdminInventory from './pages/admin/AdminInventory';
import AdminWeb3Orders from './pages/admin/AdminWeb3Orders';
import AdminAgentKeys from './pages/admin/AdminAgentKeys';
import AdminDirectorySubmissions from './pages/admin/AdminDirectorySubmissions';
import AdminDisputes from './pages/admin/AdminDisputes';
import OrderStatusPage from './pages/OrderStatusPage';
import OrderLookupPage from './pages/OrderLookupPage';
import AgentActivityPage from './pages/AgentActivityPage';
import { Toaster } from './components/ui/sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  useEffect(() => {
    axios.post(`${API_URL}/api/analytics/hit`, { page: 'homepage' }).catch(() => {});
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-[#05050A]">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/news" element={<NewsListPage />} />
          <Route path="/news/:slug" element={<NewsArticlePage />} />
          <Route path="/rfq" element={<RFQFormPage />} />
          <Route path="/agents" element={<AgentCommercePage />} />
          <Route path="/for-agents" element={<ForAgentsPage />} />
          <Route path="/order" element={<OrderLookupPage />} />
          <Route path="/order/:orderId" element={<OrderStatusPage />} />
          <Route path="/agent-activity" element={<AgentActivityPage />} />
          <Route path="/payments-race" element={<AgentActivityPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/rfqs" element={<AdminRFQs />} />
          <Route path="/admin/inventory" element={<AdminInventory />} />
          <Route path="/admin/web3-orders" element={<AdminWeb3Orders />} />
          <Route path="/admin/agent-keys" element={<AdminAgentKeys />} />
          <Route path="/admin/disputes" element={<AdminDisputes />} />
          <Route path="/admin/directory-submissions" element={<AdminDirectorySubmissions />} />
        </Routes>
        <CompareBar />
        <Toaster position="top-right" theme="dark" />
      </div>
    </Router>
  );
}

export default App;
